export const isInteractiveElement = (target: HTMLElement): boolean => {
  if (!target) {
    return false;
  }

  const tagName = target.tagName.toLowerCase();

  if (tagName === 'label' || target.closest('label')) {
    return true;
  }

  if (tagName === 'input' || target.closest('input')) {
    return true;
  }

  if (tagName === 'a' || target.closest('a')) {
    return true;
  }

  if (tagName === 'button' || target.closest('button')) {
    return true;
  }

  if (
    target.getAttribute('role') === 'button' ||
    target.closest('[role="button"]')
  ) {
    return true;
  }

  if (
    target.hasAttribute('data-row-click-disabled') ||
    target.closest('[data-row-click-disabled]')
  ) {
    return true;
  }

  if (
    target.getAttribute('data-scope') === 'menu' ||
    target.closest('[data-scope="menu"]')
  ) {
    return true;
  }

  return false;
};
